import * as React from 'react';
import { useQuery } from 'react-query';
import { api } from 'services';

import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

type DescriptionOption = {
  value: string;
  label: string;
}

export const usePrioritizedProductDescriptionOptions = () => {
  const fetchDescriptions = React.useCallback(async (): Promise<DescriptionOption[]> => {
    const { data } = await api.get<string[]>('/inventory/prioritized-products/descriptions');

    return data.map(d => ({
      value: d,
      label: d,
    }));
  }, []);

  const { data, isLoading } = useQuery({
    queryKey: ['fetch-prioritized-product-descriptions'],
    queryFn: fetchDescriptions,
    refetchOnWindowFocus: false,
  });

  return {
    singleSelectOptions: data?.map(optionsMapper) || [],
    multiSelectOptions: data?.map(multiSelectorOptionsMapper) || [],
    loading: isLoading,
  };

};